<template>
    <div>
        <div id="link-view" style="display: none;"></div>
        <div id="close-view" style="display: none;"></div>
        <div v-show="sequraCheckoutActive" ref="sequraCheckout" class="sequra-checkout"></div>
        <div v-if="apiFailed" class="app-error-info">
            <img src="../assets/images/icon_server_down.svg" />
            <div>
                Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.
            </div>
        </div>
        <div
            v-if="str"
            v-show="initialized"
            class="app-container"
            :style="{'background-color': config.backgroundColor, 'color': config.textColor}"
        >
            <div v-if="isProcessing">
                <div
                    class="app-processing"
                >
                    {{ str['processing'] }}
                </div>
            </div>
            <div v-if="!isProcessing && !subscriptionButtonLink">
                <!-- Without subscription -->
                <div v-if="withoutSubscription">
                    <div class="app-content">
                        <div v-if="paydayValid">
                            {{ str['valid_until'] }} {{ paydayText }}
                        </div>
                        <div v-if="!paydayValid && !config.subscriptionWebviewProof" class="app-title text-bold">
                            {{ str['pt_no_subscription_active'] }}
                        </div>
                    </div>
                </div>
                <!-- User not found -->
                <div v-if="user === false && config.subscription">
                    <div class="app-content">
                        <div class="app-title text-bold">
                            {{ str['user_not_found'] }}
                        </div>
                    </div>
                </div>
                <!-- Subscription disabled -->
                <div v-if="!config.subscription">
                    <div class="app-content">
                        <div class="app-title text-bold">
                            {{ str['contact_pt_more_information'] }}
                        </div>
                    </div>
                </div>
                <!-- Stripe container -->
                <div v-if="user && subscriptionStep && !config.hotmart && !config.viva_wallet && !subscriptionCancelled">
                    <div class="app-content">
                        <!-- Title -->
                        <div
                            v-if="subscriptionStep.title && !subscriptionStep.subscriptionWebviewHideTitle"
                            class="app-title text-bold"
                            v-html="str[subscriptionStep.title] ? str[subscriptionStep.title] : subscriptionStep.title"
                        ></div>
                        <!-- Subtitle -->
                        <div
                            v-if="subscriptionStep.subtitle && !user.paym_sub && !validatePaymentLink"
                            class="app-subtitle text-bold"
                            v-html="str[subscriptionStep.subtitle] ? str[subscriptionStep.subtitle] : subscriptionStep.subtitle"
                        ></div>
                        <!-- Subtitle valid payment -->
                        <div
                            v-if="subscriptionStep.subtitle_valid_payment && validatePaymentLink && validatePaymentLink !== 'processing'"
                            class="app-subtitle text-bold"
                            v-html="str[subscriptionStep.subtitle_valid_payment] ? str[subscriptionStep.subtitle_valid_payment] : subscriptionStep.subtitle_valid_payment"
                        ></div>
                        <!-- Subtitle valid payment processing -->
                        <div
                            v-if="subscriptionStep.subtitle_valid_payment_processing && validatePaymentLink === 'processing'"
                            class="app-subtitle text-bold"
                            v-html="str[subscriptionStep.subtitle_valid_payment_processing] ? str[subscriptionStep.subtitle_valid_payment_processing] : subscriptionStep.subtitle_valid_payment_processing"
                        ></div>
                        <!-- Image -->
                        <div
                            v-if="subscriptionStep.image && !user.paym_sub && !validatePaymentLink"
                            class="app-image"
                        >
                            <img :src="subscriptionStep.image" />
                        </div>
                        <!-- Info -->
                        <div
                            v-if="subscriptionStep.info && !user.paym_sub && !validatePaymentLink"
                            class="app-info"
                            v-html="str[subscriptionStep.info] ? str[subscriptionStep.info] : subscriptionStep.info"
                        ></div>
                        <!-- Stripe subscription -->
                        <div
                            v-if="config.subscription && !validatePaymentLink"
                            class="app-body"
                        >
                            <div v-if="!user.paym_sub">
                                <stripe-subscription
                                    ref="stripeRef"
                                    :step="subscriptionStep"
                                    :terms="subscriptionStep.terms"
                                    :gdpr="subscriptionStep.gdpr"
                                />
                            </div>
                            <div v-if="user.paym_sub">
                                {{ str['valid_until'] }} {{ paydayText }}
                            </div>
                            <div v-if="user.paym_sub && user.paym_info">
                                {{ user.paym_info }}
                            </div>
                        </div>
                        <!-- Footer -->
                        <div class="app-footer">
                            <div v-if="!user.paym_sub && config.subscription && !validatePaymentLink">
                                <v-btn @click="addSubscription()" class="app-button-next">
                                    {{ str['add_subscription'] }}
                                </v-btn>
                            </div>
                            <div v-if="user.paym_sub && config.subscription && !validatePaymentLink">
                                <v-btn @click="cancelSubscription()" class="app-button-next">
                                    {{ str['cancel_subscription'] }}
                                </v-btn>
                            </div>
                            <div v-if="validatePaymentLink && validatePaymentLink !== 'processing'">
                                <v-btn @click="openValidatePayment()" class="app-button-next">
                                    {{ str['confirm'] }}
                                </v-btn>
                            </div>
                            <div v-if="!validatePaymentLink || validatePaymentLink === 'processing'">
                                <v-btn @click="close()" class="app-button-back">
                                    <i class="fa fa-chevron-left"></i>
                                    <span>
                                        {{ str['back'] }}
                                    </span>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Hotmart container -->
                <div v-if="user && config.hotmart && ((hotmartSteps && hotmartSteps.length) || config.subscriptionWebviewProof) && !subscriptionCancelled">
                    <!-- Suspended client message -->
                    <div
                        v-if="!user.paym_sub && subscriptionDisabled"
                        v-html="subscriptionDisabled.message"
                        class="app-message"
                    ></div>
                    <!-- Hotmart steps -->
                    <div
                        v-if="!user.paym_sub && !subscriptionDisabled"
                        v-for="(step, index) in hotmartSteps" :key="index"
                    >
                        <div v-if="hotmartStepIndex === index" class="app-content">
                            <!-- Title -->
                            <div
                                v-if="step.title" class="app-title text-bold"
                                v-html="str[step.title] ? str[step.title] : step.title"
                            ></div>
                            <!-- Subtitle -->
                            <div
                                v-if="step.subtitle && !user.paym_sub"
                                class="app-subtitle text-bold"
                                v-html="str[step.subtitle] ? str[step.subtitle] : step.subtitle"
                            ></div>
                            <!-- Image -->
                            <div v-if="step.image && !user.paym_sub"
                                class="app-image">
                                <img :src="step.image" />
                            </div>
                            <!-- Info -->
                            <div
                                v-if="step.info && !user.paym_sub"
                                class="app-info"
                                v-html="str[step.info] ? str[step.info] : step.info"
                            ></div>
                            <!-- Promotional code button -->
                            <div
                                v-if="step.promotionalCodeButton"
                                class="app-button-element"
                            >
                                <div>
                                    <v-btn
                                        color="default"
                                        @click="applyPromotionalCode()"
                                    >
                                        {{ str['apply_promotional_code'] }}
                                    </v-btn>
                                    <div
                                        v-if="promotionalCode"
                                        class="text-success"
                                    >
                                        {{ promotionalCode }}
                                    </div>
                                </div>
                            </div>
                            <!-- Select subscription type -->
                            <div
                                v-if="step.id === 'select_subscription'"
                                class="app-buttons-flex app-buttons-flex-small"
                            >
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="nextHotmartStep(buttonElement)"
                                    v-bind:style="getButtonStyle(buttonElement)"
                                    class="v-btn"
                                    v-html="buttonElement.text"
                                ></div>
                            </div>
                            <!-- Select hotmart plan -->
                            <div
                                v-if="step.id === 'hotmart_plans'"
                                class="app-buttons-flex app-buttons-flex-small"
                            >
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="selectHotmartPlan(buttonElement)"
                                    v-bind:style="getButtonStyle(buttonElement)"
                                    class="v-btn"
                                >
                                    {{ buttonElement.text }}
                                </div>
                            </div>
                            <!-- Add proof -->
                            <div v-if="step.id === 'proof'" class="app-margin-space">
                                <photo :callback="sendPaymentProof" :size="1024" />
                            </div>
                            <!-- Webview content -->
                            <div
                                v-if="step.type === 'webview'"
                                style="margin-top: 10px;"
                            >
                                <iframe
                                    v-if="step.url"
                                    v-bind:src="step.url"
                                    style="width: 100%; height: calc(100vh - 50px);"
                                />
                            </div>
                            <div
                                v-if="hotmartStepIndex > 0 && step.id !== 'subscription_hotmart'"
                                class="app-footer"
                            >
                                <v-btn v-if="step.id !== 'success'" @click="backHotmartStep()" class="app-button-back">
                                    <i class="fa fa-chevron-left"></i>
                                    <span>
                                        {{ str['back'] }}
                                    </span>
                                </v-btn>
                                <v-btn v-if="step.id === 'success'" @click="close()" class="app-button-next">
                                    {{ str['confirm'] }}
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <div v-if="user.paym_sub && user.paym_info">
                        <b>{{ user.paym_info }}</b>
                    </div>
                    <div v-if="user.paym_sub">
                        {{ str['valid_until'] }} {{ paydayText }}
                    </div>
                    <div v-if="config.subscriptionWebviewProof && !paydayValid && !proofPaymentSent && !subscriptionDisabled">
                        <div class="app-title-centered">
                            {{ str['upload_proof_payment'] }}
                        </div>
                        <photo :callback="sendPaymentProof" :size="1024" />
                    </div>
                    <!-- Footer -->
                    <div v-if="user.paym_sub" class="app-footer">
                        <div>
                            <v-btn @click="cancelSubscription()" class="app-button-next">
                                {{ str['cancel_subscription'] }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <!-- Eupago container -->
                <div v-if="user && ((eupagoSteps && eupagoSteps.length) || config.subscriptionWebviewProof) && !subscriptionCancelled">
                    <!-- Suspended client message -->
                    <div
                        v-if="!user.paym_sub && subscriptionDisabled"
                        v-html="subscriptionDisabled.message"
                        class="app-message"
                    ></div>
                    <!-- Eupago steps -->
                    <div
                        v-if="!user.paym_sub && !subscriptionDisabled"
                        v-for="(step, index) in eupagoSteps" :key="index"
                    >
                        <div v-if="eupagoStepIndex === index" class="app-content">
                            <!-- Title -->
                            <div
                                v-if="step.title" class="app-title text-bold"
                                v-html="str[step.title] ? str[step.title] : step.title"
                            ></div>
                            <!-- Subtitle -->
                            <div
                                v-if="step.subtitle && !user.paym_sub"
                                class="app-subtitle text-bold"
                                v-html="str[step.subtitle] ? str[step.subtitle] : step.subtitle"
                            ></div>
                            <!-- Image -->
                            <div v-if="step.image && !user.paym_sub"
                                class="app-image">
                                <img :src="step.image" />
                            </div>
                            <!-- Info -->
                            <div
                                v-if="step.info && !user.paym_sub"
                                class="app-info"
                                v-html="str[step.info] ? str[step.info] : step.info"
                            ></div>
                            <!-- Promotional code button -->
                            <div
                                v-if="step.promotionalCodeButton"
                                class="app-button-element"
                            >
                                <div>
                                    <v-btn
                                        color="default"
                                        @click="applyPromotionalCode()"
                                    >
                                        {{ str['apply_promotional_code'] }}
                                    </v-btn>
                                    <div
                                        v-if="promotionalCode"
                                        class="text-success"
                                    >
                                        {{ promotionalCode }}
                                    </div>
                                </div>
                            </div>
                            <!-- Select hotmart plan -->
                            <div
                                v-if="step.id === 'eupago_plans'"
                                class="app-buttons-flex app-buttons-flex-small"
                            >
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="selectEuPagoPlan(buttonElement)"
                                    v-bind:style="getButtonStyle(buttonElement)"
                                    class="v-btn"
                                >
                                    {{ buttonElement.text }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="user.paym_sub && user.paym_info">
                        <b>{{ user.paym_info }}</b>
                    </div>
                    <div v-if="user.paym_sub">
                        {{ str['valid_until'] }} {{ paydayText }}
                    </div>
                    <div v-if="config.subscriptionWebviewProof && !paydayValid && !proofPaymentSent && !subscriptionDisabled">
                        <div class="app-title-centered">
                            {{ str['upload_proof_payment'] }}
                        </div>
                        <photo :callback="sendPaymentProof" :size="1024" />
                    </div>
                    <!-- Footer -->
                    <div v-if="user.paym_sub" class="app-footer">
                        <div>
                            <v-btn @click="cancelSubscription()" class="app-button-next">
                                {{ str['cancel_subscription'] }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <!-- Viva Wallet container -->
                <div v-if="user && config.viva_wallet && vivaWalletSteps && vivaWalletSteps.length && !subscriptionCancelled">
                    <!-- Suspended client message -->
                    <div
                        v-if="!userSubscription && subscriptionDisabled"
                        v-html="subscriptionDisabled.message"
                        class="app-message"
                    ></div>
                    <!-- Viva Wallet steps -->
                    <div
                        v-if="!userSubscription && !subscriptionDisabled"
                        v-for="(step, index) in vivaWalletSteps" :key="index"
                    >
                        <div v-if="vivaWalletStepIndex === index" class="app-content">
                            <!-- Title -->
                            <div
                                v-if="step.title" class="app-title text-bold"
                                v-html="str[step.title] ? str[step.title] : step.title"
                            ></div>
                            <!-- Subtitle -->
                            <div
                                v-if="step.subtitle"
                                class="app-subtitle text-bold"
                                v-html="str[step.subtitle] ? str[step.subtitle] : step.subtitle"
                            ></div>
                            <!-- Image -->
                            <div v-if="step.image"
                                class="app-image">
                                <img :src="step.image" />
                            </div>
                            <!-- Info -->
                            <div
                                v-if="step.info"
                                class="app-info"
                                v-html="str[step.info] ? str[step.info] : step.info"
                            ></div>
                            <!-- Promotional code button -->
                            <div
                                v-if="step.promotionalCodeButton"
                                class="app-button-element"
                            >
                                <div>
                                    <v-btn
                                        color="default"
                                        @click="applyPromotionalCode()"
                                    >
                                        {{ str['apply_promotional_code'] }}
                                    </v-btn>
                                    <div
                                        v-if="promotionalCode"
                                        class="text-success"
                                    >
                                        {{ promotionalCode }}
                                    </div>
                                </div>
                            </div>
                            <!-- Select subscription type -->
                            <div
                                v-if="step.id === 'select_subscription'"
                                class="app-buttons-flex app-buttons-flex-small"
                            >
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="nextVivaWalletStep(buttonElement)"
                                    v-bind:style="getButtonStyle(buttonElement)"
                                    class="v-btn"
                                    v-html="buttonElement.text"
                                ></div>
                            </div>
                            <!-- Select Viva Wallet plan -->
                            <div
                                v-if="step.id === 'viva_wallet_plans' || step.id === 'viva_wallet_subscription_plans'"
                                class="app-buttons-flex app-buttons-flex-small"
                            >
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="selectVivaWalletPlan(buttonElement)"
                                    v-bind:style="getButtonStyle(buttonElement)"
                                    class="v-btn app-button-card"
                                >
                                    <div v-html="buttonElement.text"></div>
                                    <div
                                        v-if="buttonElement.info"
                                        v-html="buttonElement.info"
                                    ></div>
                                </div>
                            </div>
                            <div
                                v-if="step.id === 'payments_packs_categories'"
                                class="app-buttons-flex app-buttons-flex-small"
                            >
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="selectVivaWalletPackCategory(buttonElement)"
                                    :style="getButtonStyle(buttonElement)"
                                    class="v-btn app-button-card"
                                >
                                    <div v-html="buttonElement.text"></div>
                                    <div
                                        v-if="buttonElement.info"
                                        v-html="buttonElement.info"
                                    ></div>
                                </div>
                            </div>
                            <div
                                v-if="step.id === 'payments_packs_category'"
                                class="app-buttons-flex app-buttons-flex-small"
                            >
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="selectVivaWalletPack(buttonElement)"
                                    :style="getButtonStyle(buttonElement)"
                                    class="v-btn app-button-card"
                                >
                                    <div v-html="buttonElement.text"></div>
                                    <div
                                        v-if="buttonElement.info"
                                        v-html="buttonElement.info"
                                    ></div>
                                </div>
                            </div>
                            <div
                                v-if="step.id === 'payments_pack'"
                                class="app-buttons-flex app-buttons-flex-small"
                            >
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="selectVivaWalletPackMode(buttonElement)"
                                    :style="getButtonStyle(buttonElement)"
                                    class="v-btn app-button-card"
                                >
                                    <div v-html="buttonElement.text"></div>
                                    <div
                                        v-if="buttonElement.info"
                                        v-html="buttonElement.info"
                                    ></div>
                                </div>
                            </div>
                            <!-- Add proof -->
                            <div v-if="step.id === 'proof'" class="app-margin-space">
                                <photo :callback="sendPaymentProof" :size="1024" />
                            </div>
                            <!-- Webview content -->
                            <div
                                v-if="step.type === 'webview'"
                                style="margin-top: 10px;"
                            >
                                <iframe
                                    v-if="step.url"
                                    v-bind:src="step.url"
                                    style="width: 100%; height: calc(100vh - 50px);"
                                />
                            </div>
                            <div
                                v-if="vivaWalletStepIndex > 0 && !isBooking"
                                class="app-footer"
                            >
                                <v-btn v-if="step.id !== 'success'" @click="backVivaWalletStep()" class="app-button-back">
                                    <i class="fa fa-chevron-left"></i>
                                    <span>
                                        {{ str['back'] }}
                                    </span>
                                </v-btn>
                                <v-btn v-if="step.id === 'success'" @click="close()" class="app-button-next">
                                    {{ str['confirm'] }}
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <div v-if="userSubscription && userSubscription.info">
                        <b>{{ userSubscription.info }}</b>
                    </div>
                    <div v-if="userSubscription && !userSubscription.info && user.paym_info">
                        <b>{{ user.paym_info }}</b>
                    </div>
                    <div v-if="userSubscription && !userSubscription.info">
                        {{ str['valid_until'] }} {{ paydayText }}
                    </div>
                    <!-- Footer -->
                    <div v-if="userSubscription && (userSubscription.has_subscription || userSubscription.show_update_payday)" class="app-footer">
                        <div v-if="userSubscription.has_subscription">
                            <v-btn @click="cancelSubscription()" class="app-button-next">
                                {{ str['cancel_subscription'] }}
                            </v-btn>
                        </div>
                        <div v-if="userSubscription.show_update_payday">
                            <v-btn @click="userSubscription = null" class="app-button-next">
                                {{ str['renew'] }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <!-- Stripe Plans container -->
                <div v-if="user && stripePlansSteps && stripePlansSteps.length && !subscriptionCancelled">
                    <!-- Suspended client message -->
                    <div
                        v-if="!user.paym_sub && subscriptionDisabled"
                        v-html="subscriptionDisabled.message"
                        class="app-message"
                    ></div>
                    <!-- Stripe Plans steps -->
                    <div
                        v-if="!user.paym_sub && !subscriptionDisabled"
                        v-for="(step, index) in stripePlansSteps" :key="index"
                    >
                        <div v-if="stripePlansStepIndex === index" class="app-content">
                            <!-- Title -->
                            <div
                                v-if="step.title" class="app-title text-bold"
                                v-html="str[step.title] ? str[step.title] : step.title"
                            ></div>
                            <!-- Subtitle -->
                            <div
                                v-if="step.subtitle"
                                class="app-subtitle text-bold"
                                v-html="str[step.subtitle] ? str[step.subtitle] : step.subtitle"
                            ></div>
                            <!-- Image -->
                            <div v-if="step.image"
                                class="app-image">
                                <img :src="step.image" />
                            </div>
                            <!-- Info -->
                            <div
                                v-if="step.info"
                                class="app-info"
                                v-html="str[step.info] ? str[step.info] : step.info"
                            ></div>
                            <!-- Select subscription type -->
                            <div
                                v-if="step.id === 'select_subscription'"
                                class="app-buttons-flex app-buttons-flex-small"
                            >
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="nextStripePlansStep(buttonElement)"
                                    v-bind:style="getButtonStyle(buttonElement)"
                                    class="v-btn"
                                    v-html="buttonElement.text"
                                ></div>
                            </div>
                            <!-- Select Stripe Plans plan -->
                            <div
                                v-if="step.id === 'stripe_plans'"
                                class="app-buttons-flex app-buttons-flex-small"
                            >
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="selectStripePlan(buttonElement)"
                                    v-bind:style="getButtonStyle(buttonElement)"
                                    class="v-btn"
                                    v-html="buttonElement.text"
                                ></div>
                            </div>
                            <!-- Webview content -->
                            <div
                                v-if="step.type === 'webview'"
                                style="margin-top: 10px;"
                            >
                                <iframe
                                    v-if="step.url"
                                    v-bind:src="step.url"
                                    style="width: 100%; height: calc(100vh - 50px);"
                                />
                            </div>
                            <div
                                v-if="stripePlansStepIndex > 0"
                                class="app-footer"
                            >
                                <v-btn @click="backStripePlansStep()" class="app-button-back">
                                    <i class="fa fa-chevron-left"></i>
                                    <span>
                                        {{ str['back'] }}
                                    </span>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <div v-if="user.paym_sub && user.paym_info">
                        <b>{{ user.paym_info }}</b>
                    </div>
                    <div v-if="user.paym_sub">
                        {{ str['valid_until'] }} {{ paydayText }}
                    </div>
                    <!-- Footer -->
                    <div v-if="user.paym_sub" class="app-footer">
                        <div>
                            <v-btn @click="cancelSubscription()" class="app-button-next">
                                {{ str['cancel_subscription'] }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <!-- Proof payment sent success container -->
                <div v-if="proofPaymentSent">
                    <div style="text-align: center; padding: 40px 20px;">
                        {{ str['proof_payment_sent_successfully'] }}                
                    </div>
                </div>
                <!-- Subscription cancelled container -->
                <div v-if="subscriptionCancelled">
                    <div style="text-align: center; padding: 40px 20px;">
                        {{ str['subscription_cancelled_success'] }}                
                    </div>
                </div>
            </div>
            <div v-if="!isProcessing && subscriptionButtonLink" class="app-subscription-button-link">
                <v-btn @click="openSubscriptionLink()" class="app-button-next">
                    {{ str['open'] }}
                </v-btn>
            </div>
        </div>
        <v-dialog v-model="showLoginModal" persistent max-width="400px">
            <v-card>
                <v-card-title class="headline">
                    Login
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="loginEmail"
                        label="Email"
                        type="email"
                        required
                        autofocus
                    ></v-text-field>
                    <v-text-field
                        v-model="loginPassword"
                        label="Password"
                        type="password"
                        required
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="submitLogin">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-if="showEuPagoFieldsModal" v-model="showEuPagoFieldsModal" persistent max-width="400px">
            <v-card>
                <v-card-title class="headline">
                    Atualize os dados para continuar
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="euPagoFields.tax_id_number"
                        :label="str['tax_id_number']"
                        type="text"
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="euPagoFields.address"
                        :label="str['address']"
                        type="text"
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="euPagoFields.locality"
                        :label="str['city']"
                        type="text"
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="euPagoFields.postal_code"
                        :label="str['postal_code']"
                        type="text"
                        required
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="submitEuPagoFields"
                        :disabled="!euPagoFields.tax_id_number || !euPagoFields.address || !euPagoFields.locality || !euPagoFields.postal_code"
                    >
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Api from '../services/Api'
    import Utils from '../services/Utils'
    import StripeSubscription from '@/components/StripeSubscription'
    import Photo from '@/components/Photo'
    import moment from 'moment'

    export default {
        components: {
            StripeSubscription,
            Photo,
        },
        data() {
            return {
                str: null,
                isBooking: window.bookingScheduleId ? true : false,
                apiFailed: false,
                initialized: false,
                processing: false,
                userSubscription: null,
                user: null,
                config: {},
                subscriptionStep: null,
                hotmartSteps: null,
                hotmartStepIndex: 0,
                eupagoSteps: null,
                eupagoStepIndex: 0,
                vivaWalletSteps: null,
                vivaWalletStepIndex: 0,
                stripePlansSteps: null,
                stripePlansStepIndex: 0,
                withoutSubscription: false,
                validatePaymentLink: null,
                subscriptionCancelled: false,
                subscriptionDisabled: false,
                isProcessing: false,
                promotionalCode: null,
                paydayValid: false,
                proofPaymentSent: false,
                showLoginModal: false,
                loginEmail: '',
                loginPassword: '',
                subscriptionButtonLink: null,
                showEuPagoFieldsModal: false,
                euPagoFields: {
                    tax_id_number: '',
                    address: '',
                    locality: '',
                    postal_code: '',
                },
                sequraPaymentType: 6,
                sequraCheckoutActive: false,
                sequraCheckoutOpened: false,
            }
        },
        computed: {
            paydayText () {
                if (this.user.payday) {
                    return moment(this.user.payday).subtract(1, 'days').format('YYYY-MM-DD') + ' 23h59'
                }
                return this.user.payday;
            }
        },
        beforeMount: function () {
            this.getStrings()
        },
        methods: {
            getButtonStyle: function (buttonElement, extra) {
                return Object.assign(
                    {
                        color: buttonElement.textColor,
                    },
                    Utils.getButtonBackgroundStyle(
                        buttonElement.backgroundColor,
                        buttonElement.backgroundGradient,
                        buttonElement.buttonBackground,
                    ),
                    extra || {},
                )
            },
            getStrings: function () {
                const self = this
                this.apiFailed = false
                Api.getStrings(function (response) {
                    if (response.success) {
                        window.strings = response.data
                        self.str = response.data
                        self.main()
                    } else {
                        self.apiFailed = true
                    }
                })
            },
            main: function () {
                const self = this
                this.$isLoading(true)
                Utils.refreshAppUrl()
                Api.getEnums(function () {
                    Api.getRegisterConfig(function (response) {
                        self.$isLoading(false)
                        if (response.success) {
                            self.refreshData(response.data)
                        } else {
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    })
                })
            },
            refreshData: function (config) {
                const self = this
                Utils.setConfigStrings(config)
                this.config = config
                this.subscriptionButtonLink = this.config.subscription_link
                if (this.subscriptionButtonLink) {
                    this.refreshPage()
                    return
                }
                Utils.refreshAppUrl(this.config)
                Utils.subscriptionTypeValidation(this.config)
                if (config.hotmart) {
                    this.hotmartSteps = this.getHotmartSteps()
                    if (this.hotmartSteps && this.hotmartSteps.length) {
                        this.getUser()
                    } else {
                        setWithoutSubscriptionState()
                    }
                } else if (this.config.viva_wallet) {
                    if (this.config.viva_wallet_switch_plans || (window.filteredPacks && window.filteredPacks.length)) {
                        initVivaWalletSteps()
                    } else {
                        this.getUser(function () {
                            initVivaWalletSteps(function () {
                                if (self.isAutoSelectVivaWalletPlan()) {
                                    self.selectVivaWalletPlan()
                                }
                            })
                        })
                    }
                } else if (this.isEuPago()) {
                    this.eupagoSteps = this.getEuPagoSteps()
                    if (this.eupagoSteps && this.eupagoSteps.length) {
                        this.getUser()
                    } else {
                        setWithoutSubscriptionState()
                    }
                } else {
                    initStripePlansSteps()
                    if (this.stripePlansSteps && this.stripePlansSteps.length) {
                        return true
                    }
                    this.getUser(function () {
                        self.subscriptionStep = self.getSubscriptionStep()
                        if (self.subscriptionStep) {
                            self.initialized = true
                            return true
                        }
                        if (!self.subscriptionStep && (!self.user || (self.user && !self.user.paym_sub))) {
                            setWithoutSubscriptionState()
                            return true
                        }
                        self.subscriptionStep = {}
                        self.initialized = true
                    })
                }

                function initVivaWalletSteps(cb) {
                    self.vivaWalletSteps = self.getVivaWalletSteps()
                    if (self.vivaWalletSteps && self.vivaWalletSteps.length) {
                        self.getSubscription(function () {
                            self.getUser()
                            if (cb) {
                                cb()
                            }
                        })
                    } else {
                        setWithoutSubscriptionState()
                        if (cb) {
                            cb()
                        }
                    }
                }

                function initStripePlansSteps() {
                    self.stripePlansSteps = self.getStripePlansSteps()
                    if (self.stripePlansSteps && self.stripePlansSteps.length) {
                        self.getUser(() => {
                            self.filterPacksByCategory()
                        })
                    }
                }

                function setWithoutSubscriptionState() {
                    self.getUser(() => {
                        self.paydayValid = self.user && self.user.payday && self.user.payday > moment().format('YYYY-MM-DD')
                        self.withoutSubscription = true
                        self.initialized = true
                    })
                }
            },
            isAutoSelectVivaWalletPlan: function () {
                const noSubscription = this.user && this.user.paym_sub && !this.user.paym_cus ? true : false
                const showUpdatePayday = this.userSubscription && this.userSubscription.show_update_payday ? true : false
                return noSubscription && !this.isBooking && showUpdatePayday
            },
            isEuPago: function () {
                if (this.config && this.config.steps) {
                    const step = this.config.steps.find(step => step.id === 'eupago_plans')
                    return step ? true : false
                }
                return false
            },
            getSubscription: function (callback) {
                const self = this
                Api.getSubscriptionVW(function (response) {
                    if (response.success) {
                        if ((response.data.has_subscription || response.data.info) && !self.isBooking) {
                            self.userSubscription = response.data
                        }
                        if (callback) {
                            callback()
                        }
                    } else {
                        self.processing = false
                        self.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
            getUser: function (callback) {
                const self = this
                if (!window.clientId) {
                    this.getUserCallback = callback
                    this.isProcessing = false
                    this.$isLoading(false)
                    this.showLoginModal = true
                    return
                }
                Api.getUser(function (response) {
                    self.processing = false
                    if (response.success) {
                        self.user = response.data[0] ? response.data[0] : false
                        if (!self.validateEuPagoFields()) {
                            return
                        }
                        self.validateSubscriptionStatus()
                        self.refreshPage()
                        self.refreshPacksByTags()
                        if (callback) {
                            callback()
                        }
                    } else {
                        self.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
            refreshPacksByTags: function () {
                try {
                    if (!this.config || !this.config.filterPacksByTag || !this.user || !this.user.tags || !this.user.tags.length) {
                        return
                    }
                    if (!this.vivaWalletSteps || !this.vivaWalletSteps.length) {
                        return
                    }
                    const userTags = this.user.tags.split(',')
                    if (!userTags || !userTags.length) {
                        return
                    }
                    const packsCategories = Utils.getPaymentPacksCategories()
                    if (!packsCategories || !packsCategories.length) {
                        return
                    }
                    const categoryValues = []
                    for (let i = 0; i < packsCategories.length; i++) {
                        if (!packsCategories[i].tags || !packsCategories[i].tags.length) {
                            continue
                        }
                        for (let j = 0; j < userTags.length; j++) {
                            if (packsCategories[i].tags.indexOf(userTags[j]) > -1) {
                                categoryValues.push(packsCategories[i].value)
                            }
                        }
                    }
                    if (!categoryValues.length) {
                        return
                    }
                    const packStepIds = ['viva_wallet_subscription_plans', 'viva_wallet_plans', 'payments_packs_category']
                    for (let i = 0; i < this.vivaWalletSteps.length; i++) {
                        const step = this.vivaWalletSteps[i]
                        if (packStepIds.indexOf(step.id) > -1 && step.buttons && step.buttons.length) {
                            step.buttons = step.buttons.filter((button) => {
                                return categoryValues.indexOf(button.category) > -1
                            })
                        }
                    }
                } catch {}
            },
            validateEuPagoFields: function () {
                if (!this.isEuPago()) {
                    return true
                }
                if (!this.user) {
                    return true
                }
                if (this.user.tax_id_number && this.user.address && this.user.locality && this.user.postal_code) {
                    return true
                }
                this.euPagoFields.tax_id_number = this.user.tax_id_number
                this.euPagoFields.address = this.user.address
                this.euPagoFields.locality = this.user.locality
                this.euPagoFields.postal_code = this.user.postal_code
                this.showEuPagoFieldsModal = true
                return false
            },
            submitEuPagoFields: function () {
                this.showEuPagoFieldsModal = false
                this.$isLoading(true)
                Api.updateUser({
                    tax_id_number: this.euPagoFields.tax_id_number,
                    address: this.euPagoFields.address,
                    locality: this.euPagoFields.locality,
                    postal_code: this.euPagoFields.postal_code
                }, (response) => {
                    this.$isLoading(false)
                    if (response.success) {
                        this.getUser()
                    } else {
                        this.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
            submitLogin: function () {
                const self = this
                if (!this.loginEmail || !this.loginPassword) {
                    this.$alert(
                        window.strings['fields_to_be_filled'],
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                    return
                }
                this.$isLoading(true)
                Api.login({
                    email: this.loginEmail,
                    password: this.loginPassword
                }, function (response) {
                    self.$isLoading(false)
                    if (response.success) {
                        window.clientId = response.data.id
                        self.showLoginModal = false
                        self.getUser(self.getUserCallback)
                    } else {
                        self.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
            validateSubscriptionStatus: function () {
                if (this.config.subscriptionSuspendedClientsDisabled && (this.config.subscriptionSuspendedClientsDisabled.status === this.user.status || this.config.subscriptionSuspendedClientsDisabled.status === 'all')) {
                    if (
                        this.config.subscriptionSuspendedClientsDisabled.status === 'all' &&
                        ((!this.config.viva_wallet_switch_plans && this.isAutoSelectVivaWalletPlan()) || (window.filteredPacks && window.filteredPacks.length))
                    ) {
                        this.subscriptionDisabled = false
                        return
                    }
                    this.subscriptionDisabled = this.config.subscriptionSuspendedClientsDisabled
                } else {
                    this.subscriptionDisabled = false
                }
            },
            refreshPage: function () {
                const self = this
                window.scrollTo(0, 0)
                Utils.refreshStyles(this.config, function () {
                    self.initialized = true
                    self.startSubscription()
                    self.runSkipSelectSubscriptionWithFilteredPacks()
                })
            },
            skipSelectSubscriptionWithFilteredPacks: function () {
                return window.filteredPacks && window.filteredPacks.length && this.config.skipSelectSubscriptionWithFilteredPacks ? true : false
            },
            applySkipSelectSubscriptionWithFilteredPacks: function (steps) {
                if (!this.skipSelectSubscriptionWithFilteredPacks() || !steps) {
                    return steps
                }
                let selectSubscriptionStepDeleted = false
                for (let i = steps.length - 1; i > -1; i--) {
                    if (steps[i].backStep) {
                        delete steps[i].backStep
                    }
                    if (steps[i].id === 'select_subscription') {
                        steps.splice(i, 1)
                        selectSubscriptionStepDeleted = true
                    }
                }
                if (selectSubscriptionStepDeleted) {
                    const vivaWalletSubscriptionPlansStep = steps.find(function (s) {
                        return s.id === 'viva_wallet_subscription_plans'
                    })
                    if (vivaWalletSubscriptionPlansStep) {
                        vivaWalletSubscriptionPlansStep.getPacks = true
                    }
                }
                return steps
            },
            getActivePaymentStep: function () {
                if (this.config.hotmart && this.hotmartSteps && this.hotmartSteps.length) {
                    return this.hotmartSteps[this.hotmartStepIndex]
                }
                if (this.isEuPago() && this.eupagoSteps && this.eupagoSteps.length) {
                    return this.eupagoSteps[this.eupagoStepIndex]
                }
                if (this.config.viva_wallet && this.vivaWalletSteps && this.vivaWalletSteps.length) {
                    return this.vivaWalletSteps[this.vivaWalletStepIndex]
                }
                if (this.stripePlansSteps && this.stripePlansSteps.length) {
                    return this.stripePlansSteps[this.stripePlansStepIndex]
                }
                return null
            },
            runSkipSelectSubscriptionWithFilteredPacks: function () {
                if (!this.skipSelectSubscriptionWithFilteredPacks() || !this.getActivePaymentStep() || !this.user) {
                    return
                }
                this.tryAutoSelectFilteredPackPlan()
                this.trySkipPacksCategoriesStep()
            },
            tryAutoSelectFilteredPackPlan: function () {
                const step = this.getActivePaymentStep()
                if (step && step.buttons && step.buttons.length === 1) {
                    const buttonElement = step.buttons[0]
                    switch (step.id) {
                        case 'hotmart_plans':
                            this.selectHotmartPlan(buttonElement)
                            break
                        case 'eupago_plans':
                            this.selectEuPagoPlan(buttonElement)
                            break
                        case 'stripe_plans':
                            this.selectStripePlan(buttonElement)
                            break
                        case 'viva_wallet_plans':
                        case 'viva_wallet_subscription_plans':
                            this.selectVivaWalletPlan(buttonElement)
                            break
                        case 'payments_packs_category':
                            this.selectVivaWalletPack(buttonElement)
                            break
                    }
                }
            },
            trySkipPacksCategoriesStep: function () {
                const step = this.getActivePaymentStep()
                if (step && step.id === 'payments_packs_categories') {
                    this.selectVivaWalletPackCategory({ id: null })
                }
            },
            startSubscription: function () {
                const self = this
                if (this.user &&!this.user.paym_sub && this.config.subscription && !this.subscriptionCancelled && !this.subscriptionDisabled) {
                    if (window.useHotmart) {
                        const hotmartStep = this.hotmartSteps.find(function (it) {
                            return it.id === 'hotmart_plans'
                        })
                        this.promotionalCode = null
                        if (hotmartStep && hotmartStep.promotionalCode) {
                            this.$prompt(
                                hotmartStep.promotionalCodeMessage ? hotmartStep.promotionalCodeMessage : this.str['do_you_have_promotional_code'],
                                '',
                                '',
                                '',
                                Utils.getAlertOptions()
                            ).then(text => {
                                if (text) {
                                    self.$isLoading(true)
                                    Api.getHotmartSubscriptionPlans({
                                        code: text
                                    }, function (response) {
                                        if (response.success) {
                                            if (response.data && response.data[0]) {
                                                if (response.data[0].aux_id) {
                                                    self.promotionalCode = text
                                                    self.selectHotmartPlan({
                                                        url: response.data[0].aux_id
                                                    })
                                                } else {
                                                    self.$isLoading(false)
                                                    self.$alert(
                                                        self.str['common_error'],
                                                        '',
                                                        'warning',
                                                        Utils.getAlertOptions()
                                                    )
                                                }
                                            } else {
                                                self.$isLoading(false)
                                                self.$alert(
                                                    response.message,
                                                    '',
                                                    'warning',
                                                    Utils.getAlertOptions()
                                                )
                                            }
                                        } else {
                                            self.$isLoading(false)
                                            self.$alert(
                                                response.message,
                                                '',
                                                'warning',
                                                Utils.getAlertOptions()
                                            )
                                        }
                                    })
                                }
                            }).catch(() => {})
                        }
                    } else {
                        if (this.subscriptionStep && this.subscriptionStep.promotionalCode) {
                            this.$prompt(
                                this.str['do_you_have_promotional_code'],
                                '',
                                '',
                                '',
                                Utils.getAlertOptions()
                            ).then(text => {
                                self.getSubscriptionPlans({
                                    code: text
                                })
                            }).catch(() => {
                                self.getSubscriptionPlans()
                            })
                        } else {
                            this.getSubscriptionPlans()
                        }
                    }
                }
            },
            getSubscriptionStep: function () {
                for (let i = 0; i < this.config.steps.length; i++) {
                    if (this.config.steps[i].id === 'subscription') {
                        return this.config.steps[i]
                    }
                }
            },
            getHotmartSteps: function () {
                const self = this
                const steps = []
                const ids = ['select_subscription', 'hotmart_plans', 'subscription_hotmart', 'proof']
                for (let i = 0; i < this.config.steps.length; i++) {
                    if (ids.indexOf(this.config.steps[i].id) > -1) {
                        steps.push(this.config.steps[i])
                    }
                }
                this.applySkipSelectSubscriptionWithFilteredPacks(steps)
                const plansStep = steps.find(function (st) {
                    return st.id === 'hotmart_plans'
                })
                if (plansStep && plansStep.buttons && !plansStep.buttons.length) {
                    this.getPacks({
                        callback: function (packs) {
                            if (packs.length) {
                                plansStep.buttons = packs
                            }
                            self.runSkipSelectSubscriptionWithFilteredPacks()
                        }
                    })
                } else if (this.skipSelectSubscriptionWithFilteredPacks()) {
                    this.$nextTick(function () {
                        self.runSkipSelectSubscriptionWithFilteredPacks()
                    })
                }
                return steps
            },
            getEuPagoSteps: function () {
                const self = this
                const steps = []
                const ids = ['eupago_plans']
                for (let i = 0; i < this.config.steps.length; i++) {
                    if (ids.indexOf(this.config.steps[i].id) > -1) {
                        steps.push(this.config.steps[i])
                    }
                }
                const plansStep = steps.find(function (st) {
                    return st.id === 'eupago_plans'
                })
                if (plansStep && plansStep.buttons && !plansStep.buttons.length) {
                    this.getPacks({
                        gateway: plansStep.gateway,
                        callback: function (packs) {
                            if (packs.length) {
                                plansStep.buttons = packs
                            }
                            self.runSkipSelectSubscriptionWithFilteredPacks()
                        }
                    })
                } else if (this.skipSelectSubscriptionWithFilteredPacks()) {
                    this.$nextTick(function () {
                        self.runSkipSelectSubscriptionWithFilteredPacks()
                    })
                }
                return steps
            },
            applyPromotionalCode: function () {
                const self = this
                const currentStep = this.vivaWalletSteps ? this.vivaWalletSteps[this.vivaWalletStepIndex] : null
                this.$prompt(
                    currentStep && currentStep.promotionalCodeMessage ? currentStep.promotionalCodeMessage : this.str['do_you_have_promotional_code'],
                    '',
                    '',
                    '',
                    Utils.getAlertOptions()
                ).then(text => {
                    self.getSubscriptionPlans({
                        code: text,
                        usePacks: true
                    })
                }).catch(() => { })
            },
            getSubscriptionPlans: function (payload) {
                const self = this
                if (this.subscriptionStep) {
                    this.$isLoading(true)
                    Api.getSubscriptionPlans(payload ? payload.code : null, function (response) {
                        self.$isLoading(false)
                        if (response.success) {
                            for (let i = 0; i < self.subscriptionStep.fields.length; i++) {
                                if (self.subscriptionStep.fields[i].id == 'price_id') {
                                    const newItems = []
                                    for (let s = 0; s < response.data.length; s++) {
                                        const priceJson = response.data[s].prices[0]
                                        if (priceJson) {
                                            newItems.push({
                                                label: self.subscriptionStep.useNickname && priceJson.nickname ? priceJson.nickname : response.data[s].name,
                                                value: priceJson.id,
                                                order: response.data[s].metadata && response.data[s].metadata.order ? parseInt(response.data[s].metadata.order) : null
                                            })
                                        }
                                    }
                                    self.subscriptionStep.fields[i].items = newItems.sort(function(a, b) {
                                        const itemA = a.order || a.order === 0 ? a.order : a.label.toLowerCase()
                                        const itemB = b.order || b.order === 0 ? b.order : b.label.toLowerCase()
                                        if (itemA < itemB) {
                                            return -1
                                        }
                                        if (itemA > itemB) {
                                            return 1
                                        }
                                        return 0
                                    })
                                    self.$set(self.subscriptionStep.fields, i, self.subscriptionStep.fields[i])
                                    break
                                }
                            }
                        } else {
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            ).then(() => {
                                self.startSubscription()
                            })
                        }
                    })
                    return
                }

                const vivaWalletStepsIds = ['viva_wallet_subscription_plans', 'viva_wallet_plans']
                if (this.vivaWalletSteps && this.vivaWalletSteps[this.vivaWalletStepIndex] && vivaWalletStepsIds.includes(this.vivaWalletSteps[this.vivaWalletStepIndex].id)) {
                    this.getVivaWalletSteps({
                        promotionalCode: payload ? payload.code : null,
                        callback:function (steps) {
                            const stepData = steps.find(s => s.id === self.vivaWalletSteps[self.vivaWalletStepIndex].id)
                            if (stepData) {
                                self.vivaWalletSteps[self.vivaWalletStepIndex] = stepData
                                self.promotionalCode = payload.code
                            }
                        }
                    })
                    return
                }

                const hotmartStepsIds = ['hotmart_plans']
                if (this.hotmartSteps && this.hotmartSteps[this.hotmartStepIndex] && hotmartStepsIds.includes(this.hotmartSteps[this.hotmartStepIndex].id)) {
                    this.applyPromotionalCodeHotmart(payload ? payload.code : null)
                    return
                }

                if (payload && payload.code && payload.usePacks) {
                    let gateway = null
                    if (this.isEuPago() && this.eupagoSteps && this.eupagoSteps.length) {
                        const euPagoStep = this.eupagoSteps.find(function (st) {
                            return st.id === 'eupago_plans'
                        })
                        if (euPagoStep && euPagoStep.gateway) {
                            gateway = euPagoStep.gateway
                        }
                    }
                    this.$isLoading(true)
                    this.getPacks({
                        code: payload.code,
                        gateway: gateway,
                        callback: function (packs) {
                            if (packs && packs.length) {
                                self.promotionalCode = payload.code
                                self.updateCurrentStepField('buttons', packs)
                                self.$isLoading(false)
                                self.runSkipSelectSubscriptionWithFilteredPacks()
                            }
                        }
                    })
                }
            },
            applyPromotionalCodeHotmart: function (text) {
                const self = this
                this.$isLoading(true)
                Api.getHotmartSubscriptionPlans({
                    code: text,
                },
                function (response) {
                    if (response.success) {
                        if (response.data && response.data[0]) {
                            if (response.data[0].aux_id) {
                                self.promotionalCode = text
                                self.selectHotmartPlan({
                                    url: response.data[0].aux_id,
                                })
                                return true
                            }
                            self.$isLoading(false)
                            self.$alert(self.str['common_error'], '', 'warning', Utils.getAlertOptions())
                        } else {
                            self.$isLoading(false)
                            self.$alert(response.message, '', 'warning', Utils.getAlertOptions())
                        }
                    } else {
                        self.$isLoading(false)
                        self.$alert(response.message, '', 'warning', Utils.getAlertOptions())
                    }
                })
            },
            updateCurrentStepField: function (field, value) {
                let steps = this.stripePlansSteps
                let index = this.stripePlansStepIndex
                if (this.config.hotmart) {
                    steps = this.hotmartSteps
                    index = this.hotmartStepIndex
                }
                if (this.isEuPago()) {
                    steps = this.eupagoSteps
                    index = this.eupagoStepIndex
                }
                if (this.config.viva_wallet) {
                    steps = this.vivaWalletSteps
                    index = this.vivaWalletStepIndex
                }
                if (steps[index]) {
                    steps[index][field] = value
                    this.$set(steps, index, steps[index])
                }
            },
            addSubscription: function () {
                const self = this

                if (!this.processing) {
                    if (this.$refs.stripeRef.validated()) {
                        this.$isLoading(true)
                        this.processing = true

                        let data = this.getData()
                        data.pt_id = window.ptId
                        data.id = this.user.id
                        data.customer_id = this.user.paym_cus
                        data.customer_email = this.user.email
                        data.customer_name = this.user.name
                        data.customer_description = 'APP ' + window.ptId + ' - ' + this.user.name

                        Api.addSubscription(data, function (response) {
                            self.$isLoading(false)
                            if (response.success) {
                                if (response.data && response.data.linvoice_url) {
                                    self.validatePaymentLink = response.data.linvoice_url
                                }
                                self.getUser()
                            } else {
                                self.processing = false
                                self.$alert(
                                    response.message,
                                    '',
                                    'warning',
                                    Utils.getAlertOptions()
                                )
                            }
                        })
                    }
                }
            },
            validateFields: function () {
                const currentStep = this.subscriptionStep
                let valid = true
                let fieldsValue = {}
                for (let i = 0; i < currentStep.fields.length; i++) {
                    const field = currentStep.fields[i]
                    fieldsValue[field.id] = field.value
                    if (field.required && !checkValue(field.value)) {
                        valid = false
                    }
                    if (field.sameValue && fieldsValue[field.sameValue] !== field.value) {
                        this.$alert(
                            field.failedMessage,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                        return false
                    }
                }
                if (valid) {
                    return true
                } else {
                    this.$alert(
                        currentStep.emptyFailedMessage,
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                    return false
                }

                function checkValue (value) {
                    const valueStr = value.toString()
                    if (valueStr.replace(/\s/g, '').length) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            getData: function () {
                let data = {}
                for (let i = 0; i < this.subscriptionStep.fields.length; i++) {
                    if (this.subscriptionStep.fields[i].inputType == 'numeric') {
                        data[this.subscriptionStep.fields[i].id] = parseFloat(this.subscriptionStep.fields[i].value)
                    } else {
                        data[this.subscriptionStep.fields[i].id] = this.subscriptionStep.fields[i].value
                    }
                }
                return data
            },
            cancelSubscription: function () {
                const self = this

                if (this.hasCancelSubscriptionLink()) {
                    return this.$confirm(
                        window.strings[this.config.cancelSubscriptionLink.text] ? window.strings[this.config.cancelSubscriptionLink.text] : this.config.cancelSubscriptionLink.text,
                        null,
                        null,
                        Utils.getAlertOptions({
                            confirm: window.strings[this.config.cancelSubscriptionLink.confirmText] ? window.strings[this.config.cancelSubscriptionLink.confirmText] : this.config.cancelSubscriptionLink.confirmText,
                            cancel: window.strings[this.config.cancelSubscriptionLink.cancelText] ? window.strings[this.config.cancelSubscriptionLink.cancelText] : this.config.cancelSubscriptionLink.cancelText,
                        })
                    ).then(() => {
                        let text = '&text='
                        text += window.strings['id'] + ': ' + self.user.id + '\n' + window.strings['email'] + ': ' + self.user.email + '\n' + window.strings['name'] + ': ' + self.user.name
                        text += '\n\n' + window.strings['want_cancel_subscription']
                        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                            window.ReactNativeWebView.postMessage(JSON.stringify({
                                event: 'link',
                                data: self.config.cancelSubscriptionLink.link + text
                            }))
                        }
                    }).catch(() => {})
                }

                if (!this.processing) {
                    this.$confirm(
                        this.str['are_you_sure_cancel_subscription'],
                        null,
                        null,
                        Utils.getAlertOptions({
                            confirm: window.strings['yes'],
                            cancel: window.strings['no']
                        })
                    ).then(() => {
                        self.$isLoading(true)
                        self.processing = true
                        Api.cancelSubscription(self.user, function (response) {
                            self.$isLoading(false)
                            if (response.success) {
                                self.subscriptionCancelled = true
                                self.getUser()
                                self.$alert(
                                    self.str['subscription_cancelled_success'],
                                    '',
                                    'success',
                                    Utils.getAlertOptions()
                                ).then(r => {
                                    self.close()
                                })
                            } else {
                                self.$alert(
                                    response.message,
                                    '',
                                    'warning',
                                    Utils.getAlertOptions()
                                )
                            }
                        })
                    }).catch(() => {})
                }
            },
            close: function () {
                if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                    if (window.appReceiveData || this.hasCancelSubscriptionLink()) {
                        return window.ReactNativeWebView.postMessage(JSON.stringify({
                            event: 'close'
                        }))
                    }
                    window.ReactNativeWebView.postMessage('close')
                }
            },
            hasCancelSubscriptionLink: function () {
                if (this.config.cancelSubscriptionLink && window.appVersion && window.appVersion >= this.config.cancelSubscriptionLink.minAppVersion) {
                    return true
                }
                return false
            },
            sendEventToApp: function (event, data) {
                if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({
                        event: event,
                        data: data
                    }))
                }
            },
            openValidatePayment: function () {
                window.open(this.validatePaymentLink)
                this.validatePaymentLink = 'processing'
            },
            openSubscriptionLink: function () {
                window.open(this.subscriptionButtonLink, '_self')
            },
            selectEuPagoPlan: function (item) {
                if (!this.user) {
                    this.isProcessing = false
                    this.$isLoading(false)
                    return
                }
                this.isProcessing = true
                this.$isLoading(true)
                const ptTag = this.getPtKey().toLowerCase()
                Api.createOrderEuPago({
                    payment_identifier: `${ptTag}_cus_${this.user.id}_${item.id}_${new Date().getTime()}`,
                    payment_amount_value: item.amount / 100,
                    payment_success_url: `https://vivawallet.mkgest.com/?success=1&pt_id=${window.ptId}`,
                    payment_failure_url: `https://vivawallet.mkgest.com/?success=0&pt_id=${window.ptId}`,
                    customer_email: this.user.email,
                    customer_name: this.user.name,
                    customer_vat_number: this.user.tax_id_number,
                    customer_billing_address: this.user.address,
                    customer_billing_zip_code: this.user.postal_code,
                    customer_billing_city: this.user.locality,
                    item_description: item.text,
                },  (response) => {
                    if (response.success && response.data && response.data.checkoutUrl) {
                        const openLink = () => {
                            this.sendEventToApp('start-payment', this.user)
                            setTimeout(() => {
                                window.open(response.data.checkoutUrl, '_self')
                            })
                        }
                        if (item && item.id) {
                            Api.updateUser({
                                pack_id: item.id
                            }, (respUser) => {
                                this.$isLoading(false)
                                if (respUser.success) {
                                    openLink()
                                } else {
                                    this.$alert(
                                        respUser.message,
                                        '',
                                        'warning',
                                        Utils.getAlertOptions()
                                    )
                                }
                            })
                        } else {
                            this.$isLoading(false)
                            openLink()
                        }
                    } else {
                        this.$isLoading(false)
                        this.isProcessing = false
                        this.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
            selectHotmartPlan: function (item) {
                const self = this

                for (let i = 0; i < this.hotmartSteps.length; i++) {
                    if (this.hotmartSteps[i].id === 'subscription_hotmart') {
                        const params = []
                        if (this.user && this.user.email) {
                            params.push('email=' + this.user.email)
                        }
                        if (this.user && this.user.name) {
                            params.push('name=' + this.user.name)
                        }
                        if (params.length) {
                            const joiner = item.url.indexOf('?') !== -1 ? '&' : '?'
                            this.hotmartSteps[i].url = item.url + joiner + params.join('&')
                        } else {
                            this.hotmartSteps[i].url = item.url
                        }
                        break
                    }
                }

                if (this.promotionalCode) {
                    Api.updateUser({
                        promo_code: this.promotionalCode
                    }, function (response) {
                        self.$isLoading(false)
                        if (response.success) {
                            self.nextHotmartStep()
                        } else {
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    })
                } else {
                    this.nextHotmartStep()
                }
            },
            nextHotmartStep: function (item) {
                const newIndex = item && item.step ? this.hotmartSteps.findIndex(function (s) {
                    return s.id === item.step
                }) : (this.hotmartStepIndex + 1)
                if (this.hotmartSteps[newIndex]) {
                    this.hotmartStepIndex = newIndex
                    this.runSkipSelectSubscriptionWithFilteredPacks()
                }
            },
            nextVivaWalletStep: function (item) {
                const newIndex = item && item.step ? this.vivaWalletSteps.findIndex(function (s) {
                    return s.id === item.step
                }) : (this.vivaWalletStepIndex + 1)
                if (this.vivaWalletSteps[newIndex]) {
                    this.vivaWalletStepIndex = newIndex
                    this.runSkipSelectSubscriptionWithFilteredPacks()
                }
            },
            backVivaWalletStep: function () {
               this.vivaWalletStepIndex = 0
            },
            backHotmartStep: function () {
                this.hotmartStepIndex = 0
            },
            getVivaWalletSteps: function (args) {
                const self = this
                const promotionalCode = args && args.promotionalCode ? args.promotionalCode : null
                const steps = []
                const ids = ['select_subscription', 'viva_wallet_subscription_plans', 'viva_wallet_plans', 'payments_packs_categories', 'payments_packs_category', 'payments_pack', 'proof']
                for (let i = 0; i < this.config.steps.length; i++) {
                    if (ids.indexOf(this.config.steps[i].id) > -1) {
                        steps.push(this.config.steps[i])
                    }
                }
                this.applySkipSelectSubscriptionWithFilteredPacks(steps)
                // Packs
                const vivaWalletSubscriptionPlansStep = steps.find(function (st) {
                    return st.id === 'viva_wallet_subscription_plans'
                })
                const vivaWalletPlansStep = steps.find(function (st) {
                    return st.id === 'viva_wallet_plans'
                })
                const paymentsPacksCategoryStep = this.config.steps.find(function (st) {
                    return st.id === 'payments_packs_category'
                })
                if ((paymentsPacksCategoryStep && paymentsPacksCategoryStep.buttons && !paymentsPacksCategoryStep.buttons.length) ||
                    (
                        vivaWalletSubscriptionPlansStep && vivaWalletSubscriptionPlansStep.buttons && (!vivaWalletSubscriptionPlansStep.buttons.length || promotionalCode) &&
                        vivaWalletPlansStep && vivaWalletPlansStep.buttons && (!vivaWalletPlansStep.buttons.length || promotionalCode)
                    ) ||
                    (
                        vivaWalletSubscriptionPlansStep && vivaWalletSubscriptionPlansStep.getPacks &&
                        vivaWalletSubscriptionPlansStep.buttons && (!vivaWalletSubscriptionPlansStep.buttons.length || promotionalCode)
                    )
                ) {
                    this.getPacks({
                        code: promotionalCode,
                        callback: function (packs) {
                            const selectSubscriptionStep = steps.find(s => s.id === 'select_subscription')
                            const hasProofStep = selectSubscriptionStep && selectSubscriptionStep.buttons ? selectSubscriptionStep.buttons.find(b => b.step === 'proof') : false
                            const subscriptionPacks = packs.filter(function (pack) {
                                return pack.allow_recurring
                            })
                            const noSubscriptionPacks = JSON.parse(JSON.stringify(packs.filter(function (pack) {
                                return pack.allow_one_time_payments
                            })))
                            for (let s = 0; s < noSubscriptionPacks.length; s++) {
                                noSubscriptionPacks[s].allow_recurring = false
                            }
                            for (let r = steps.length - 1; r > -1; r--) {
                                if (steps[r] && steps[r].backStep === 'select_subscription' && (!subscriptionPacks.length || !noSubscriptionPacks.length) && !hasProofStep) {
                                    delete steps[r].backStep
                                }
                                if (steps[r] && steps[r].id === 'select_subscription' && (!subscriptionPacks.length || !noSubscriptionPacks.length) && !hasProofStep) {
                                    if (subscriptionPacks.length || noSubscriptionPacks.length) {
                                        steps.splice(r, 1)
                                    } else {
                                        delete steps[r].buttons
                                        delete steps[r].goToStep
                                        steps[r].image = 'https://ptclient.mkgest.com/app/media/payment_failed.png'
                                        steps[r].info = window.strings['payments_packs_empty']
                                    }
                                    continue
                                }
                                if (steps[r] && steps[r].id === 'select_subscription' && (!subscriptionPacks.length || !noSubscriptionPacks.length) && hasProofStep) {
                                    if (!subscriptionPacks.length && steps[r].buttons) {
                                        steps[r].buttons = steps[r].buttons.filter(b => b.step !== 'viva_wallet_subscription_plans')
                                    }
                                    if (!noSubscriptionPacks.length && steps[r].buttons) {
                                        steps[r].buttons = steps[r].buttons.filter(b => b.step !== 'viva_wallet_plans')
                                    }
                                    continue
                                }
                                if (steps[r] && steps[r].id === 'viva_wallet_subscription_plans') {
                                    if (subscriptionPacks.length) {
                                        steps[r].buttons = subscriptionPacks
                                    } else {
                                        steps.splice(r, 1)
                                    }
                                    continue
                                }
                                if (steps[r] && steps[r].id === 'viva_wallet_plans') {
                                    if (noSubscriptionPacks.length) {
                                        steps[r].buttons = noSubscriptionPacks
                                    } else {
                                        steps.splice(r, 1)
                                    }
                                    continue
                                }
                                if (steps[r] && steps[r].id === 'payments_packs_category') {
                                    steps[r].buttons = packs
                                    continue
                                }
                                if (steps[r] && steps[r].id === 'payments_packs_categories') {
                                    const packsCategories = Utils.getPaymentPacksCategories()
                                    const cats = []
                                    if (packsCategories) {
                                        packsCategories.forEach(function (c) {
                                            cats.push({
                                                id: c.value,
                                                textColor: self.config.packTextColor,
                                                backgroundColor: self.config.packBackgroundColor,
                                                backgroundGradient: self.config.packBackgroundGradient,
                                                text: c.label,
                                                booking: c.booking
                                            })
                                        })
                                    }
                                    steps[r].buttons = cats
                                    continue
                                }
                            }
                            if (self.isBooking) {
                                for (let i = 0; i < steps.length; i++) {
                                    if (steps[i].id === 'payments_packs_categories') {
                                        const bookingCategory = steps[i].buttons.find(b => b.booking)
                                        if (bookingCategory) {
                                            self.selectVivaWalletPackCategory(bookingCategory)
                                        }
                                        break
                                    }
                                }
                            } else {
                                self.runSkipSelectSubscriptionWithFilteredPacks()
                            }
                            if (args && args.callback) {
                                args.callback(steps)
                            }
                        }
                    })
                } else if (this.skipSelectSubscriptionWithFilteredPacks()) {
                    this.$nextTick(function () {
                        self.runSkipSelectSubscriptionWithFilteredPacks()
                    })
                }
                return steps
            },
            selectVivaWalletPackCategory: function (item) {
                const self = this
                this.$isLoading(true)
                this.getPacks({
                    category: item.id,
                    callback: function (packs) {
                        self.$isLoading(false)
                        for (let r = self.config.steps.length - 1; r > -1; r--) {
                            if (self.config.steps[r].id === 'payments_packs_category') {
                                self.config.steps[r].buttons = packs
                            }
                        }
                        self.nextVivaWalletStep()
                    }
                })
            },
            selectVivaWalletPack: function (item) {
                const data = JSON.parse(JSON.stringify(item))
                this.vivaWalletPackSelected = data
                if (this.isSequraFlow()) {
                    return this.selectVivaWalletPlan(data)
                }
                if (data.allow_recurring && (data.allow_one_time_payments || data.allow_installments)) {
                    return this.nextVivaWalletStep()
                }
                if (window.configType === 'klarna' && !data.allow_recurring && !data.allow_one_time_payments && data.allow_installments) {
                    return this.selectVivaWalletPlan(data)
                }
                data.allow_recurring = !data.allow_one_time_payments ? true : false
                this.selectVivaWalletPlan(data)
            },
            selectVivaWalletPackMode: function (item) {
                if (item.allow_recurring) {
                    this.vivaWalletPackSelected.allow_recurring = true
                    this.vivaWalletPackSelected.allow_one_time_payments = false
                } else {
                    this.vivaWalletPackSelected.allow_recurring = false
                }
                this.selectVivaWalletPlan(this.vivaWalletPackSelected)
            },
            selectVivaWalletPlan: function (item) {
                const self = this
                if (!this.user) {
                    this.isProcessing = false
                    this.$isLoading(false)
                    return
                }
                if (item && this.isSequraFlow() && !this.isBooking) {
                    return this.createSequraOrder(item)
                }
                this.isProcessing = true
                this.$isLoading(true)
                const tagsData = item ? {
                    paym_subt: item.paym_subt,
                    allow_recurring: item.allow_recurring,
                    promo_code: this.promotionalCode ? this.promotionalCode : '',
                    client_id: this.user.id,
                } : null
                if (item && item.contents) {
                    tagsData.content_purchased = JSON.parse(item.contents)
                }
                if (self.isBooking && item) {
                    tagsData.booking_sale = true
                    return Api.newBooking({
                        booking_schedule_id: parseInt(window.bookingScheduleId),
                        date: window.bookingDate,
                        status: 'pending'
                    }, function (response) {
                        if (response.success) {
                            tagsData.booking_id = response.data.id
                            createOrder()
                        } else {
                            self.$isLoading(false)
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    })
                }

                createOrder()

                function createOrder() {
                    Api.createOrderVW(item ? {
                        amount: item.amount,
                        customerTrns: item.text,
                        customer: {
                            email: self.user.email,
                            fullName: self.user.name,
                            phone: self.user.mobile_phone
                        },
                        allowRecurring: item.allow_recurring,
                        allow_one_time_payments: item.allow_one_time_payments,
                        allow_installments: item.allow_installments,
                        tags:[JSON.stringify(tagsData)]
                    } : {
                        id: self.user.id
                    }, function (response) {
                        if (response.success && response.data && response.data.order_url) {
                            if (item && item.id && !self.isBooking) {
                                Api.updateUser({
                                    pack_id: item.id
                                }, function (respUser) {
                                    self.$isLoading(false)
                                    if (respUser.success) {
                                        openLink()
                                    } else {
                                        self.$alert(
                                            respUser.message,
                                            '',
                                            'warning',
                                            Utils.getAlertOptions()
                                        )
                                    }
                                })
                            } else {
                                self.$isLoading(false)
                                openLink()
                            }

                            function openLink() {
                                self.sendEventToApp('start-payment', self.user)
                                setTimeout(function () {
                                    window.open(response.data.order_url, '_self')
                                })
                            }
                        } else {
                            self.$isLoading(false)
                            self.isProcessing = false
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    })
                }
            },
            isSequraFlow: function () {
                return window.configType === 'sequra'
            },
            getPtKey: function () {
                const foundKey = Object.keys(PTS_IDS).find((k) => PTS_IDS[k] === window.ptId)
                return foundKey ? foundKey : ''
            },
            getSequraCustomer: function (user) {
                const getValue = (value) => {
                    if (value || value === 0) {
                        return String(value).trim()
                    }
                    return ''
                }
                const name = getValue(user.name).replace(/\s+/g, ' ')
                const nameSpaceIndex = name.indexOf(' ')
                const customer = {
                    given_names: nameSpaceIndex > -1 ? name.substring(0, nameSpaceIndex) : name,
                    surnames: nameSpaceIndex > -1 ? name.substring(nameSpaceIndex + 1) : name,
                    email: getValue(user.email),
                    address_line_1: getValue(user.address),
                    postal_code: getValue(user.postal_code),
                    city: getValue(user.locality),
                }
                const phone = getValue(user.mobile_phone)
                if (phone) {
                    customer.phone = phone
                }
                const vatNumber = getValue(user.tax_id_number)
                if (vatNumber) {
                    customer.vat_number = vatNumber
                    customer.nin = vatNumber
                }
                const birthDate = getValue(user.birth_date)
                if (birthDate) {
                    customer.date_of_birth = birthDate
                }
                const countryCode = getValue(user.country)
                if (/^[a-zA-Z]{2}$/.test(countryCode)) {
                    customer.country_code = countryCode.toUpperCase()
                }
                if (window.language) {
                    customer.language_code = window.language
                }
                return customer
            },
            getSequraIpAddress: function () {
                return fetch('https://api.ipify.org?format=json')
                    .then((response) => response.json())
                    .then((data) => {
                        return data && data.ip ? data.ip : null
                    })
                    .catch(() => null)
            },
            createSequraOrder: async function (item) {
                const failed = (message) => {
                    this.isProcessing = false
                    this.$isLoading(false)
                    this.$alert(
                        message || window.strings['common_error'],
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                }
                const ptKey = this.getPtKey()
                const ptSlug = ptKey.toLowerCase()
                const amountCents = Math.round(Number(item.amount))
                const customer = this.getSequraCustomer(this.user)

                if (!ptSlug || !this.user.id || !this.user.db_id || !item.id || !(amountCents >= 1) || !customer) {
                    return failed()
                }

                this.isProcessing = true
                this.$isLoading(true)

                const ipNumber = await this.getSequraIpAddress()
                if (!ipNumber) {
                    return failed()
                }
                customer.ip_number = ipNumber

                Api.sendPayment({
                    id: this.user.db_id,
                    type: this.sequraPaymentType,
                    value: amountCents / 100,
                    status: 0,
                    pack_id: item.id,
                }, (paymentResponse) => {
                    if (!paymentResponse.success) {
                        return failed(paymentResponse.message)
                    }
                    const payment = paymentResponse.data
                    const token = payment ? payment.token : null
                    if (!token) {
                        return failed(window.strings['sequra_authentication_error'])
                    }
                    const externalPaymentId = `cus_${ptSlug}_${this.user.id}_${payment.id}`
                    if (!payment.id || externalPaymentId.length > 64) {
                        return failed()
                    }
                    const sequraConfig = this.config.sequra || {}
                    const orderData = {
                        ...sequraConfig,
                        external_payment_id: externalPaymentId,
                        amount_cents: amountCents,
                        currency: 'EUR',
                        pack_ref: `pack-${item.id}`,
                        customer: customer,
                    }
                    Api.createOrderSequra(orderData, `Bearer ${token}`, (response) => {
                        const order = response.data
                        if (!response.success || !order || !order.formHtml) {
                            return failed(response.message)
                        }
                        Api.updateUser({
                            pack_id: item.id
                        }, (respUser) => {
                            if (!respUser.success) {
                                return failed(respUser.message)
                            }
                            this.sendEventToApp('start-payment', this.user)
                            this.$isLoading(false)
                            if (!this.openSequraCheckout(order.formHtml)) {
                                failed()
                            }
                        })
                    })
                })
            },
            openSequraCheckout: function (formHtml) {
                if (this.sequraCheckoutOpened) {
                    return true
                }
                if (!formHtml || !this.$refs.sequraCheckout) {
                    return false
                }
                try {
                    this.injectSequraFormHtml(this.$refs.sequraCheckout, formHtml)
                    this.sequraCheckoutOpened = true
                    this.sequraCheckoutActive = true
                    return true
                } catch {
                    this.$refs.sequraCheckout.innerHTML = ''
                    return false
                }
            },
            injectSequraFormHtml: function (target, html) {
                const template = document.createElement('div')
                template.innerHTML = html
                target.innerHTML = ''
                while (template.firstChild) {
                    target.appendChild(template.firstChild)
                }
                const scripts = Array.from(target.querySelectorAll('script'))
                scripts.forEach((oldScript) => {
                    const script = document.createElement('script')
                    Array.from(oldScript.attributes).forEach((attr) => {
                        script.setAttribute(attr.name, attr.value)
                    })
                    if (!oldScript.src) {
                        script.textContent = oldScript.textContent
                    }
                    oldScript.parentNode.replaceChild(script, oldScript)
                })
            },
            nextStripePlansStep: function (item) {
                const newIndex = item.step ? this.stripePlansSteps.findIndex(function (s) {
                    return s.id === item.step
                }) : (this.stripePlansStepIndex + 1)
                if (this.stripePlansSteps[newIndex]) {
                    this.stripePlansStepIndex = newIndex
                    this.runSkipSelectSubscriptionWithFilteredPacks()
                }
            },
            backStripePlansStep: function () {
               this.stripePlansStepIndex = 0
            },
            getStripePlansSteps: function () {
                const self = this
                const steps = []
                const ids = ['stripe_plans']
                for (let i = 0; i < this.config.steps.length; i++) {
                    if (ids.indexOf(this.config.steps[i].id) > -1) {
                        steps.push(this.config.steps[i])
                    }
                }
                // Packs
                const stripePlansStepIndex = steps.findIndex(function (st) {
                    return st.id === 'stripe_plans'
                })
                const stripePlansStep = steps[stripePlansStepIndex]
                if (stripePlansStep && stripePlansStep.buttons && !stripePlansStep.buttons.length) {
                    this.getPacks({
                        callback: function (packs) {
                            if (packs.length) {
                                stripePlansStep.buttons = packs
                            }
                            self.runSkipSelectSubscriptionWithFilteredPacks()
                        }
                    })
                } else if (this.skipSelectSubscriptionWithFilteredPacks()) {
                    this.$nextTick(function () {
                        self.runSkipSelectSubscriptionWithFilteredPacks()
                    })
                }
                return steps
            },
            filterPacksByCategory: function () {
                try {
                    const possibleKeys = ['hotmart_plans', 'stripe_plans', 'eupago_plans'] 
                    const step = this.config.steps.find(s => possibleKeys.includes(s.id))
                    if (step && step.filter_packs_category) {
                        switch (step.filter_packs_category.field) {
                            case 'country':
                                if (this.user && this.user.country) {
                                    const paymentsPacksCategories = Utils.getPaymentPacksCategories()
                                    const foundKey = paymentsPacksCategories.find((c) => c.slug === this.user.country)
                                    if (foundKey) {
                                        step.buttons = step.buttons.filter((button) => button.category === foundKey.value)
                                    } else {
                                        step.buttons = step.buttons.filter((button) => !button.category)
                                    }
                                }
                                break
                        }
                    }
                    this.runSkipSelectSubscriptionWithFilteredPacks()
                } catch {}
            },
            selectStripePlan: function (item) {
                const self = this
                if (!this.user) {
                    this.isProcessing = false
                    return
                }
                this.isProcessing = true
                if (item.id) {
                    Api.updateUser({
                        pack_id: item.id
                    }, function (response) {
                        if (response.success) {
                            openLink()
                        } else {
                            self.isProcessing = false
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    })
                } else {
                    openLink()
                }

                function openLink() {
                    self.sendEventToApp('start-payment', self.user)
                    setTimeout(function () {
                        const email = self.user && self.user.email ? '?prefilled_email=' + self.user.email : ''
                        window.open(item.url + email, '_self')
                    })
                }
            },
            getPacks: function (args) {
                const self = this
                const callback = args.callback
                const code = args.code
                const category = args.category
                const ignoreUserId = args.ignoreUserId
                const gateway = args.gateway
                const hasFilteredPacks = window.filteredPacks && window.filteredPacks.length
                const packCategories = self.config.packCategories
                const hasPackCategories = packCategories && packCategories.length
                this.$isLoading(true)
                Api.getPacks({
                    code: code,
                    category: category,
                    ignore_user_id: ignoreUserId,
                    gateway: gateway
                }, function (response) {
                    if (!ignoreUserId && (!response.success || (response.success && !response.data.length))) {
                        args.ignoreUserId = true
                        return self.getPacks(args)
                    }
                    self.$isLoading(false)
                    if (response.success) {
                        const packs = []
                        for (let i = 0; i < response.data.length; i++) {
                            const pack = response.data[i]
                            const isBookingPack = pack.type && pack.type.includes('booking');
                            if (pack.hidden && !hasFilteredPacks && !hasPackCategories) {
                                continue
                            }
                            if (!window.filteredPacks && self.config.hide_booking_packs && 
                                ((self.isBooking && !isBookingPack) || (!self.isBooking && isBookingPack))
                            ) {
                                continue
                            }
                            if (hasFilteredPacks && !window.filteredPacks.includes(pack.id)) {
                                continue
                            }
                            if (hasPackCategories) {
                                const matchCategory = packCategories.some(function (c) {
                                    return c == pack.category
                                })
                                if (!matchCategory) {
                                    continue
                                }
                            }
                            if (self.config.excludePaymentGateways && self.config.excludePaymentGateways.includes(pack.gateway)) {
                                continue
                            }
                            if (window.showOnlyKlarnaPacks && !pack.allow_installments) {
                                continue
                            }
                            if (!window.showOnlyKlarnaPacks && self.config.hideKlarnaPacks && pack.allow_installments) {
                                continue
                            }
                            if (self.isSequraFlow() && !pack.allow_installments) {
                                continue
                            }
                            packs.push({
                                id: pack.id,
                                textColor: self.config.packTextColor,
                                backgroundColor: self.config.packBackgroundColor,
                                backgroundGradient: self.config.packBackgroundGradient,
                                text: pack.name,
                                info: !self.config.hidePackPrice ? self.getPackInfo(pack) : null,
                                amount: pack.price,
                                allow_recurring: pack.allow_recurring ? true : false,
                                allow_one_time_payments: pack.allow_one_time_payments ? true : false,
                                allow_installments: pack.allow_installments ? true : false,
                                paym_subt: pack.type,
                                contents: pack.contents,
                                category: pack.category,
                                url: pack.url
                            })
                        }
                        callback(packs)
                    } else {
                        self.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
            getPackInfo: function (pack) {
                const price = pack.price / 100
                const split = pack.type.split('#')
                const type = split[1]
                const quantity = parseInt(split[0])
                let key = ''
                if (type === 'day') {
                    key = quantity > 1 ? 'days' : 'day'
                }
                if (type === 'week') {
                    key = quantity > 1 ? 'weeks' : 'week'
                }
                if (type === 'month') {
                    key = quantity > 1 ? 'months' : 'month'
                }
                if (type === 'year') {
                    key = quantity > 1 ? 'years' : 'year'
                }
                if (type === 'booking') {
                    key = quantity > 1 ? 'bookings' : 'booking'
                }
                return price + '€ / ' + (quantity > 1 ? (quantity + ' ') : '') + (key ? window.strings[key] : type)
            },
            sendPaymentProof: function (image) {
                const self = this
                const successStep = this.config.steps.find(s => s.id === 'success')
                let isVivaWallet = false
                let isHotmart = false
                if (successStep) {
                    delete successStep.info
                    delete successStep.subtitle
                    if (this.vivaWalletSteps && this.vivaWalletSteps.length) {
                        this.vivaWalletSteps.push(successStep)
                        isVivaWallet = true
                    }
                    if (this.hotmartSteps && this.hotmartSteps.length) {
                        this.hotmartSteps.push(successStep)
                        isHotmart = true
                    }
                }
                Api.sendPayment({
                    id: this.user.db_id,
                    type: 0,
                    proof: image,
                }, function (response) {
                    if (response.success) {
                        let currentStep = null
                        if (isVivaWallet) {
                            currentStep = self.vivaWalletSteps ? self.vivaWalletSteps[self.vivaWalletStepIndex] : null
                        }
                        if (isHotmart) {
                            currentStep = self.hotmartSteps ? self.hotmartSteps[self.hotmartStepIndex] : null
                        }
                        if (currentStep && currentStep.id === 'proof') {
                            if (successStep) {
                                if (isVivaWallet) {
                                    self.nextVivaWalletStep({
                                        step: 'success'
                                    })
                                }
                                if (isHotmart) {
                                    self.nextHotmartStep({
                                        step: 'success'
                                    })
                                }
                            } else {
                                self.close()
                            }
                        } else {
                            self.proofPaymentSent = true
                        }
                    } else {
                        self.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
        },
    }
</script>